import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

/** Shared CFO critical-results fetch chrome for Open ride enablement (header + activities). */
@Injectable({ providedIn: "root" })
export class CriticalResultsUiState {
	private readonly loadingSubject = new BehaviorSubject(false);
	private readonly errorSubject = new BehaviorSubject(false);

	loading$ = this.loadingSubject.asObservable();
	error$ = this.errorSubject.asObservable();

	setLoading = (loading: boolean) => this.loadingSubject.next(loading);
	setError = (error: boolean) => this.errorSubject.next(error);

	reset = () => {
		this.loadingSubject.next(false);
		this.errorSubject.next(false);
	};
}
